import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Pagination,
  LoadedContent,
  TableContainer,
} from '@occc/ui-design-system';
import { RetailerNetworkForMemberFragment } from '@occc/graphql';
import { useGetRetailerNetworksForMember } from '@occc-app/dataAccessLayer/membership/queries';

import { RetailerNetworksForMemberRow } from './RetailerNetworksForMemberRow';

type RetailerNetworksForMemberTableProps = {
  employeeRetailerNetworks: ReturnType<typeof useGetRetailerNetworksForMember>;
};

export const RetailerNetworksForMemberTable = ({
  employeeRetailerNetworks,
}: RetailerNetworksForMemberTableProps) => {
  const { loading, error, data, paginationProps } = employeeRetailerNetworks;

  const renderData = (items: RetailerNetworkForMemberFragment[]) => (
    <TableContainer>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Network Name</TableCell>
            <TableCell>Locations</TableCell>
            <TableCell>Employee Type</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {items.map((retailerNetwork) => (
            <RetailerNetworksForMemberRow
              key={retailerNetwork.uuid}
              retailerNetwork={retailerNetwork}
            />
          ))}
        </TableBody>
      </Table>
      <Pagination {...paginationProps} />
    </TableContainer>
  );

  return (
    <LoadedContent<RetailerNetworkForMemberFragment>
      error={error}
      loading={loading}
      items={data}
      renderData={renderData}
    />
  );
};
